import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useBreadcrumbs } from '../lib/navigation';

/**
 * Trilha de navegação.
 *
 * Não renderiza nada na raiz, onde a trilha teria um item só. O último item é
 * o lugar atual: sem link e marcado com `aria-current`, para leitor de tela
 * anunciar corretamente onde a pessoa está.
 */
export function Breadcrumbs() {
  const crumbs = useBreadcrumbs();
  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Trilha de navegação" className="border-b border-slate-200 bg-white/60 print:hidden">
      <ol className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-1.5 gap-y-1 px-4 py-2.5 text-sm sm:px-6">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <li key={`${crumb.label}-${index}`} className="flex items-center gap-1.5">
              {index > 0 && (
                <ChevronRight className="size-3.5 shrink-0 text-slate-300" aria-hidden />
              )}
              {crumb.to && !isLast ? (
                <Link
                  to={crumb.to}
                  className="rounded text-slate-500 underline-offset-4 transition-colors hover:text-brand-700 hover:underline"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span
                  className={isLast ? 'font-medium text-slate-700' : 'text-slate-400'}
                  {...(isLast ? { 'aria-current': 'page' as const } : {})}
                >
                  {crumb.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
